<div class="row pt-2 pb-2 bg-white">
  <div class="col-12">

    <!-- Title -->
    <div class="row pb-2 border-bottom">
      <div class="col-12">
       <span class="text-muted fw-bold">Retailers ({{ retailersSelected.length }})</span>
      </div>
    </div>

    <!-- Retailers List -->
    <div class="row">
      <div class="col-12">

        <!-- Loader & Empty message -->
        <div class="row">
          <div class="col-12 text-center">
            <div class="spinner-border text-info mt-4" role="status" *ngIf="retailersLoading === true"></div>

            <div class="col-12 text-center text-danger mt-4" *ngIf="retailersLoading === false && retailers.length == 0">Retailers not found</div>
          </div>
        </div>

        <!-- Retailer -->
        <div class="row mt-2">
          <div class="col-6 col-md-4 text-center" *ngFor="let retailer of retailers">

            <div class="retailer-outer">
              <div class="form-check form-switch selection" (change)="onRetailerClick(retailer, $event)">
                <input type="checkbox" class="form-check-input" [id]="retailer.retailer_id" [checked]="isRetailerSelected(retailer)">
                <label class="form-check-label" [for]="retailer.retailer_id"></label>
              </div>

              <img class="img-fluid" [src]="retailer.logo">

              <div class="name text-muted">{{ retailer.retailer_name }}</div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Next/Previuos Buttons -->
    <div class="row mt-3 pt-3 mb-0 border-top">
      <div class="col-6">

      </div>
      <div class="col-6 text-end">
        <button type="button" class="btn btn-secondary text-white fw-bold" title="Build Coupon" (click)="onNavigationClick('previous')">
          <i-bs class="text-light" name="arrowLeft" width="22" height="22"></i-bs>
        </button>
        &nbsp;
        <button type="button" class="btn btn-secondary text-white fw-bold" title="Coupon Details" (click)="onNavigationClick('next')">
          <i-bs class="text-light" name="arrowRight" width="22" height="22"></i-bs>
        </button>
      </div>
    </div>

  </div>
</div>

